import * as React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import Checkbox from '@liveauctioneers/caterwaul-components/lib/Checkbox/Checkbox';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import noop from '@/utils/noop';
import notificationPermissions from '@/enums/notificationPermissions';

type Props = {
    body?: string;
    forceEnableNotificationsBanner: Function;
    intl: IntlShape;
    permission: string;
    requestBrowserPermission: Function;
    setPermission: Function;
};

class EnableNotifications extends React.Component<Props> {
    static defaultProps = {
        body: '',
        permission: notificationPermissions.DEFAULT,
        requestBrowserPermission: noop,
        setPermission: noop,
    };

    requestPermission = () => {
        if (this.props.permission === notificationPermissions.DENIED) {
            this.props.forceEnableNotificationsBanner();
        } else {
            this.props.requestBrowserPermission();
        }
    };

    turnOffPermission = () => {
        this.props.setPermission(false);
    };

    requestBrowserPermission = () => {
        this.props.requestBrowserPermission();
    };

    onClick = () => {
        const { permission } = this.props;
        //permission currently granted
        if (permission === notificationPermissions.GRANTED) {
            this.props.setPermission(false);
        } else {
            if (this.props.permission === notificationPermissions.DENIED) {
                this.props.forceEnableNotificationsBanner();
            } else {
                this.props.requestBrowserPermission();
            }
        }
    };

    render() {
        const { intl, permission } = this.props;
        const show = permission !== notificationPermissions.UNSUPPORTED;
        const permissionGranted = permission === notificationPermissions.GRANTED;
        const message = permissionGranted
            ? 'notifications.notifications_enabled'
            : 'notifications.get_notifications_browser';
        const linkText = permissionGranted
            ? 'notifications.turn_off_notifications'
            : 'notifications.enable_notifications';
        const onClick = permissionGranted ? this.turnOffPermission : this.requestPermission;

        let body = (
            <>
                <FormattedMessage id={message} />
                <br />
                <Link onClick={onClick}>
                    <FormattedMessage id={linkText} />
                </Link>
            </>
        );

        if (this.props.body === 'absenteebidmodal') {
            body = (
                <Checkbox
                    checked={permissionGranted}
                    label={intl.formatMessage({ id: 'notifications.outbid_notify' })}
                    name="enableNotificationsCheckbox"
                    onClick={this.onClick}
                />
            );
        }

        return show && body;
    }
}

export default injectIntl(EnableNotifications);
